import React from 'react';
import { FN110, FN111 } from '../../../services/pwn201Api';

interface Props {
  formData: FN110;
  selectedRow: FN111 | null;
  rows: FN111[];
  isEditing: boolean;
  onAdd: () => void;
  onDelete: (idx: number) => void;
  onChange: (idx: number, field: keyof FN111, value: unknown) => void;
  onSelectRow: (idx: number) => void;
}

const dateDisplay = (v: string | null) => (v ? v.substring(0, 10) : '');

const TabShipDetails: React.FC<Props> = React.memo(({ formData, selectedRow, rows, isEditing, onAdd, onDelete, onChange, onSelectRow }) => (
  <div className="pwn201-tab-content">
    {/* Read-only summary fields */}
    <div style={{ display: 'flex', gap: 16, marginBottom: 12, flexWrap: 'wrap' }}>
      <span>總項數: <strong>{formData.fn110_32 ?? rows.length}</strong></span>
      {selectedRow && (
        <>
          <span>交運項次: <strong>{selectedRow.fn111_12}</strong></span>
          <span>S/C下單日: <strong>{dateDisplay(selectedRow.fn111_20)}</strong></span>
          <span>S/C交期: <strong>{dateDisplay(selectedRow.fn111_21)}</strong></span>
          <span>交運日期: <strong>{dateDisplay(selectedRow.fn111_22)}</strong></span>
        </>
      )}
    </div>

    {isEditing && (
      <div className="pwn201-tab-toolbar">
        <button onClick={onAdd} className="btn-add">+ 新增交運明細</button>
      </div>
    )}
    <table className="pwn201-grid">
      <thead>
        <tr>
          <th>項次</th>
          <th>交運單號</th>
          <th>產品代號</th>
          <th>客訴數量</th>
          <th>客訴金額</th>
          <th>產品代號</th>
          <th>交運量</th>
          <th>幣別</th>
          <th>布料類別</th>
          {isEditing && <th>操作</th>}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, idx) => (
          <tr key={idx} onClick={() => onSelectRow(idx)} style={{ cursor: 'pointer', background: selectedRow === row ? '#e6f7ff' : undefined }}>
            <td>{row.fn111_02}</td>
            <td>
              <input
                value={row.fn111_11}
                onChange={(e) => onChange(idx, 'fn111_11', e.target.value)}
                disabled={!isEditing}
              />
            </td>
            <td>
              <input
                value={row.fn111_13}
                onChange={(e) => onChange(idx, 'fn111_13', e.target.value)}
                disabled={!isEditing}
              />
            </td>
            <td>
              <input
                type="number"
                value={row.fn111_14}
                onChange={(e) => onChange(idx, 'fn111_14', parseFloat(e.target.value) || 0)}
                disabled={!isEditing}
              />
            </td>
            <td>
              <input
                type="number"
                value={row.fn111_16}
                onChange={(e) => onChange(idx, 'fn111_16', parseFloat(e.target.value) || 0)}
                disabled={!isEditing}
              />
            </td>
            <td>
              <input
                type="number"
                value={row.fn111_23}
                onChange={(e) => onChange(idx, 'fn111_23', parseFloat(e.target.value) || 0)}
                disabled={!isEditing}
              />
            </td>
            <td>
              <input
                type="number"
                value={row.fn111_24}
                onChange={(e) => onChange(idx, 'fn111_24', parseFloat(e.target.value) || 0)}
                disabled={!isEditing}
              />
            </td>
            <td>
              <input
                value={row.fn111_17}
                onChange={(e) => onChange(idx, 'fn111_17', e.target.value)}
                disabled={!isEditing}
              />
            </td>
            <td>
              <input
                value={row.fn111_18}
                onChange={(e) => onChange(idx, 'fn111_18', e.target.value)}
                disabled={!isEditing}
              />
            </td>
            {isEditing && (
              <td>
                <button onClick={() => onDelete(idx)} className="btn-delete">刪除</button>
              </td>
            )}
          </tr>
        ))}
        {rows.length === 0 && (
          <tr><td colSpan={isEditing ? 10 : 9} style={{ textAlign: 'center', color: '#999' }}>無資料</td></tr>
        )}
      </tbody>
    </table>
  </div>
));

export default TabShipDetails;
